import React, { useState } from 'react'

import RequestService from 'services/request.service'
import DeckService from 'services/deck.service'

import { useActionless, useAppSelector } from 'redux/hooks'
import { DECK_PATCH_SUCCEEDED } from 'redux/deck/actions/types'

import PhatButton from 'components/formElements/PhatButton'

import styles from './featuredDeckImage.module.scss'
import CardAutocomplete from 'components/formElements/CardAutocomplete'
import { CardType } from 'types/deck'
import { getArtUrl } from 'utils/ImageUrl'

type Props = {}

const FeaturedDeckImage = ({}: Props) => {
  const deckId = useAppSelector(state => state.deck.id)
  const customFeatured = useAppSelector(state => state.deck.customFeatured)

  const [deckPatchSucceeded] = useActionless(DECK_PATCH_SUCCEEDED)
  const [loading, setLoading] = useState(false)

  const handleResetImage = () => {
    const body = { customFeatured: '' }

    setLoading(true)

    DeckService.update(deckId, body)
      .then(_data => deckPatchSucceeded(body))
      .catch(RequestService.createToast)
      .finally(() => setLoading(false))
  }

  const handleSetDeckImage = (card: CardType) => {
    const customFeatured = getArtUrl(card.setCode, card.uid, false)

    const body = { customFeatured }

    setLoading(true)

    DeckService.update(deckId, body)
      .then(_data => deckPatchSucceeded(body))
      .catch(RequestService.createToast)
      .finally(() => {
        // without the timeout, the loader is removed too fast otherwise most of the time
        setTimeout(() => setLoading(false), 1000)
      })
  }

  return (
    <div className={styles.container}>
      {customFeatured && (
        <>
          <p>
            You currently have a custom featured image set for this deck. If you'd like to revert to the automatic
            selection, hit the button below.
          </p>

          <PhatButton onClick={handleResetImage}>
            {loading ? 'Changing deck image...' : 'Autoselect deck image'}
          </PhatButton>
        </>
      )}

      {!customFeatured && (
        <>
          <p>
            We are currently selecting a featured card image from your deck automatically. If you'd like to set it
            yourself, open a card menu and hit the 'Set Deck Image' button or search for a card below.
          </p>

          <CardAutocomplete
            header="Card search"
            fetchCard
            onSelect={handleSetDeckImage}
            placeholder="Atraxa, Praetors' Voice"
          />
        </>
      )}
    </div>
  )
}

export default FeaturedDeckImage
